import React, { useReducer, useState, useContext } from "react";
import { API } from "aws-amplify";

import {
  Typography,
  Button,
  Stepper,
  Step,
  StepLabel,
  Card,
  CardHeader,
  CardContent,
  Avatar,
  IconButton,
} from "@material-ui/core";
import teal from "@material-ui/core/colors/teal";
import { makeStyles } from "@material-ui/core/styles";

import clsx from "clsx";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import SettingsIcon from "@material-ui/icons/Settings";

import { YardInfo } from "./YardInfo";
import { AccessAndCapacity } from "./AccessAndCapacity";
import SetupContext from "./context";
import setupReducer from "./reducer";
import { emailYardInfoHTML } from "./emailYardInfoHTML";
import useToast from "../utils/useToast";
import { logError } from "../utils/appUtils";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  finishContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginTop: theme.spacing(4),
  },
  avatar: {
    color: theme.palette.getContrastText(theme.palette.secondary.main),
    backgroundColor: teal[500],
  },
  button: {
    marginRignt: theme.spacing(4),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  actions: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(4),
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(4),
  },
  stepAvatar: {
    backgroundColor: theme.palette.secondary.main,
    width: theme.spacing(6),
    height: theme.spacing(6),
  },
  note: {
    marginBottom: theme.spacing(2),
    mardinRight: theme.spacing(4),
    mardinLeft: theme.spacing(4),
  },
}));

function getSteps() {
  return ["Business Info", "Access and Capacity"];
}

function getStepContent(step) {
  switch (step) {
    case 0:
      return <YardInfo />;
    case 1:
      return <AccessAndCapacity />;
    default:
      return "Unknown step";
  }
}

const stepKeys = ["yardInfo", "yardInfo", ""];

const useStepStyles = makeStyles((theme) => ({
  stepRoot: {
    color: "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center",
  },
  active: {
    color: theme.palette.secondary.main,
  },
  circle: {
    width: 36,
    height: 36,
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
  text: {
    marginTop: 3,
    display: "flex",
    justifyContent: "center",
    alighItems: "center",
    color: theme.palette.getContrastText("#000"),
  },
  completed: {
    color: theme.palette.secondary.main,
    zIndex: 1,
    fontSize: 32,
  },
}));

function StepIcon(props) {
  const classes = useStepStyles();
  const { active, completed, icon } = props;
  return (
    <div
      className={clsx(classes.stepRoot, {
        [classes.active]: active,
      })}
    >
      {completed ? (
        <CheckCircleOutlineIcon
          style={{ fontSize: 36 }}
          className={classes.completed}
        />
      ) : (
        <div className={classes.circle}>
          <Typography variant="h6" className={classes.text}>
            {icon}
          </Typography>
        </div>
      )}
    </div>
  );
}

const Setup = ({ setupData, completeSetup, handleCancel, handleSave }) => {
  const classes = useStyles();
  let initState = useContext(SetupContext);
  initState = { ...JSON.parse(setupData), validators: initState.validators };
  const [state, dispatch] = useReducer(setupReducer, initState);
  const [activeStep, setActiveStep] = useState(
    initState?.activeStep ? initState.activeStep : 0
  );
  const showToast = useToast();

  const steps = getSteps();

  const handleNext = async () => {
    debugger;
    let validator = state.validators[activeStep];
    if (validator) {
      let data = state[stepKeys[activeStep]];
      let errors = validator(data);
      if (Object.keys(errors).length > 0) {
        dispatch({ type: "ERROR", payload: errors });
        return;
      }
    }
    try {
      dispatch({ type: "CLEAR_ERROR" });
      await handleSave(activeStep, state);
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      if (activeStep === steps.length - 1) {
        debugger;
      }
    } catch (err) {
      logError("newYard:Setup:handleNext", err, false);
      showToast();
    }
  };

  const finishSetup = () => {
    try {
      debugger;
      completeSetup(activeStep, state);

      API.post("transREST", "/sendEmail", {
        body: {
          to: "support@transloads.co",
          subject: "NEW YARD REGISTRATION",
          template: "emailTemplateWide.html",
          htmlContent: emailYardInfoHTML(state.yardInfo),
        },
      });
    } catch (err) {
      logError("newYard:Setup:finishSetup", err, false);
      showToast();
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleCloseSetup = async () => {
    try {
      debugger;
      const setupData = await handleSave(activeStep, state);
      dispatch({ type: "UPDATE_STATE", payload: setupData });
      handleCancel();
    } catch (err) {
      showToast();
      logError("newYard:Setup:handleCloseSetup", err, false);
    }
  };

  return (
    <SetupContext.Provider value={{ state, dispatch }}>
      <Card className={classes.card}>
        <CardHeader
          avatar={
            <Avatar className={classes.avatar}>
              <SettingsIcon fontSize="large" />
            </Avatar>
          }
          title={<Typography variant="h6">Yard Setup</Typography>}
          subheader={
            <Typography>Any questions? Call us at 1-877-TRANSLOAD</Typography>
          }
          action={
            <IconButton edge="start" onClick={handleCloseSetup}>
              <HighlightOffIcon fontSize="large" />
            </IconButton>
          }
        />
        <CardContent>
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label, index) => {
              return (
                <Step key={label}>
                  <StepLabel StepIconComponent={StepIcon}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
          {activeStep === steps.length ? (
            <div className={classes.finishContainer}>
              <Typography variant="h6" align="center" gutterBottom>
                You are all done! Click FINISH to submit your Transload Setup.
              </Typography>
              <div className={classes.actions}>
                <Button
                  onClick={() => setActiveStep(0)}
                  className={classes.button}
                  size="large"
                >
                  Go Back
                </Button>

                <Button
                  onClick={finishSetup}
                  color="secondary"
                  variant="contained"
                  size="large"
                >
                  Finish
                </Button>
              </div>
            </div>
          ) : (
            <div>
              {getStepContent(activeStep)}
              <div className={classes.actions}>
                <Button
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  className={classes.button}
                  size="large"
                >
                  Back
                </Button>

                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handleNext}
                  size="large"
                >
                  Next
                </Button>
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </SetupContext.Provider>
  );
};

export default Setup;
